
<template>
	<v-container fluid grid-list-md pa-0>
		<v-flex xs12 md12 px-0 py-2 elevation-0>
			<div class="flex">
				<h3>Actief</h3>
				<v-data-iterator
					content-tag="v-layout"
					row
					wrap
					:hide-actions="true"
					:items="activeUnits"
					:rows-per-page-items="rowsPerPageItems"
					:pagination.sync="pagination"
					no-data-text="Geen proefritten"
				>
					<v-flex slot="item" slot-scope="props" xs12 sm6 md4 lg3 d-flex>
						<unit-track-card :item="props.item">
							<div slot="subheader" class="subHeader">
								<status-indicator
									positive
									pulse
									v-if="props.item.active == '1'"
									style="transform: translate(35%,0);"
									class="right"
								></status-indicator
								>{{ props.item.pos.s }} km/u
								<br />
								<v-progress-circular
									v-if="!props.item.location"
									indeterminate
									color="primary"
								></v-progress-circular
								>{{ props.item.location }}
							</div>
							<v-flex xs12>
								<v-text-field
									label="Omschrijving"
									type="text"
									v-model="props.item.testDriveDescription"
									@change="updateTestDrive(props.item)"
								></v-text-field>
							</v-flex>
							<v-btn
								v-if="props.item.active == '0'"
								color="blue darken-1"
								flat
								@click="startTestDrive(props.item)"
								>Start</v-btn
							>
							<v-btn
								v-if="props.item.active == '1'"
								color="red darken-1"
								flat
								@click="stopTestDrive(props.item)"
								>Stop</v-btn
							>
						</unit-track-card>
					</v-flex>
				</v-data-iterator>
			</div>

			<div class="flex px-0 py-4">
				<h3>Inactief</h3>
				<v-data-iterator
					content-tag="v-layout"
					row
					wrap
					:hide-actions="true"
					:items="inActiveUnits"
					:rows-per-page-items="rowsPerPageItems"
					:pagination.sync="pagination"
					no-data-text="Alle units zijn in gebruik"
				>
					<v-flex slot="item" slot-scope="props" xs12 sm6 md4 lg3 d-flex>
						<unit-track-card :item="props.item">
							<div slot="subheader">
								<status-indicator
									positive
									pulse
									v-if="props.item.active == '1'"
									style="transform: translate(35%,0);"
									class="right"
								></status-indicator>
								{{ props.item.pos.s }} km/u
								<br />
								<v-progress-circular
									v-if="!props.item.location"
									indeterminate
									color="primary"
								></v-progress-circular>
								{{ props.item.location }}
							</div>
							<v-flex xs12>
								<v-text-field
									label="Omschrijving"
									type="text"
									v-model="props.item.startDescription"
								></v-text-field>
							</v-flex>
							<v-btn
								v-if="props.item.active == '0'"
								color="blue darken-1"
								flat
								@click="startTestDrive(props.item)"
								>Start</v-btn
							>
							<v-btn
								v-if="props.item.active == '1'"
								color="red darken-1"
								flat
								@click="stopTestDrive(props.item)"
								>Stop</v-btn
							>
						</unit-track-card>
					</v-flex>
				</v-data-iterator>
			</div>
		</v-flex>
	</v-container>
</template>
<script>
import * as utils from '@/utils/utils';
import UnitTrackCard from '@/components/TestDrives/UnitTrackCard';
import { StatusIndicator } from 'vue-status-indicator';
import moment from 'moment';
import { _ } from 'vue-underscore';

export default {
	name: 'ActiveTestDrives',
	components: { UnitTrackCard, StatusIndicator },
	data() {
		return {
			dialog: false,
			rowsPerPageItems: [4, 8, 12],
			loop: null,
			pagination: {
				rowsPerPage: 4
			},
			items: [
				{
					s: '',
					pos: {},
					location: 1
				}
			],
			description: '',
			utils: utils
		};
	},
	props: ['active'],
	mounted() {
		var self = this;
		this.getUnits();

		window.emitter.$on('newEvents', data => {
			if (self.$route.name.indexOf('TestDrive') >= 0) {
				self.getPositions(data);
			}
		});
	},
	beforeDestroy() {
		console.log('clear interval');
		window.emitter.$off('newEvents');
	},
	watch: {},
	computed: {
		activeUnits: function() {
			return this.items.filter(function(item) {
				return item.active == '1';
			});
		},
		inActiveUnits: function() {
			return this.items.filter(function(item) {
				return item.active == '0';
			});
		}
	},
	methods: {
		getUnits() {
			var self = this;
			utils
				.getData(basePath + 'api/TestDrives/testDriveUnits')
				.then(function(json) {
					if (json && json.data) {
						self.items = json.data;
						self.getLocations();
					}
				});
		},
		getLocations() {
			var coords = '';
			for (var i = 0; i < this.items.length; i++) {
				var item = this.items[i];

				coords = [
					{
						lat: item.pos.y,
						lon: item.pos.x
					}
				];

				this.getUnitLocation(item, coords);
			}
		},
		getPositions(updatedUnits) {
			var self = this;

			for (var i = 0; i < updatedUnits.length; i++) {
				var unit = updatedUnits[i];
				if (unit.d.pos) {
					let currentUnit = _.findWhere(this.items, {
						wialonUnitId: String(unit.i)
					});
					if (currentUnit) {
						currentUnit.pos = unit.d.pos;
						let coords = [];
						coords.push({
							lat: currentUnit.pos.y,
							lon: currentUnit.pos.x
						});

						this.getUnitLocation(currentUnit, coords);
					}
				}
			}
		},
		getUnitLocation(item, coords) {
			var self = this;
			utils
				.setData(basePath + 'api/rentunits/getUnitLocation/' + item.unitId, {
					coords: coords
				})
				.then(function(json) {
					if (json && json.data && json.data.length) {
						var location = json.data[0].replace(/,/g, ' ');
						self.$set(item, 'location', location);
					}
					if (json && json.sensors && json.sensors) {
						self.$set(item, 'sensors', json.sensors);
					}
				});
		},
		editTestDrive(item) {
			this.dialog = true;
		},
		updateTestDrive(item) {
			var self = this;
			var timeStamp = moment().unix();

			var data = {
				unitId: item.unitId,
				description: item.testDriveDescription,
				timeStamp: item.timeStamp
			};

			utils
				.setData(basePath + 'api/reservations/updateTestDrive/', data)
				.then(function(json) {
					if (json && json.data) {
					}
				});
		},
		startTestDrive(item) {
			var self = this;
			var timeStamp = moment().unix();

			var data = {
				unitId: item.unitId,
				timeStamp: timeStamp,
				description: item.startDescription
			};

			utils
				.setData(basePath + 'api/reservations/startTestDrive/', data)
				.then(function(json) {
					if (json && json.data) {
						item.active = true;
						item.testDriveDescription = item.startDescription;
						item.timeStamp = timeStamp;
						item.startDate = new Date();
					}
				});
		},
		stopTestDrive(item) {
			var self = this;
			var data = {
				id: item.id,
				unitId: item.unitId,
				timeStamp: item.timeStamp,
				description: item.testDriveDescription
			};

			utils
				.setData(basePath + 'api/reservations/stopTestDrive/', data)
				.then(function(json) {
					if (json && json.data) {
						item.active = false;
						item.startDescription = '';
					}
				});
		},
		getMapsUrl(item) {
			var pos = item.pos.y + ',' + item.pos.x;
			var color = item.color ? item.color.toLowerCase() : 'red';
			var key = 'AIzaSyCgaCVWpKectL7lCRTC7oriHlBx7I_bV3w';
			var url =
				'//maps.googleapis.com/maps/api/staticmap?center=' +
				pos +
				'&zoom=14&size=400x400&markers=color:' +
				color +
				'%7C' +
				pos +
				'&key=' +
				key;
			return url;
		}
	}
};
</script>
<style lang="scss">
.subHeader {
	min-height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/TestDrives/ActiveTestDrives.vue